// src/components/NumPad.jsx
// Собственная экранная числовая клавиатура.
// Не зависит от системной — пишет в строковое значение через onChange.

export default function NumPad({ value, onChange, allowDecimal = true }) {
  const press = (char) => {
    let v = String(value || '');
    if (char === 'back') {
      v = v.slice(0, -1);
    } else if (char === ',') {
      if (!allowDecimal) return;
      if (v.includes(',') || v.includes('.')) return;
      if (v === '') v = '0';
      v += ',';
    } else {
      if (v === '0') v = char;
      else v += char;
    }
    onChange(v);
  };

  const Btn = ({ children, onClick, label, dim }) => (
    <button
      type="button"
      onClick={onClick}
      style={{
        height: 52,
        background: 'var(--bg-elevated)',
        color: dim ? 'var(--fg-faint)' : 'var(--fg-strong)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-sm)',
        fontSize: 22, fontWeight: 700,
        cursor: 'pointer', fontFamily: 'var(--font-display)',
        fontVariantNumeric: 'tabular-nums',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        userSelect: 'none', WebkitUserSelect: 'none',
        transition: 'transform 80ms var(--ease-spring)',
      }}
      onTouchStart={(e) => e.currentTarget.style.transform = 'scale(0.96)'}
      onTouchEnd={(e) => e.currentTarget.style.transform = ''}
      onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.96)'}
      onMouseUp={(e) => e.currentTarget.style.transform = ''}
      onMouseLeave={(e) => e.currentTarget.style.transform = ''}
      aria-label={label}
    >
      {children}
    </button>
  );

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gap: 6,
      marginTop: 12,
    }}>
      <Btn onClick={() => press('1')}>1</Btn>
      <Btn onClick={() => press('2')}>2</Btn>
      <Btn onClick={() => press('3')}>3</Btn>
      <Btn onClick={() => press('4')}>4</Btn>
      <Btn onClick={() => press('5')}>5</Btn>
      <Btn onClick={() => press('6')}>6</Btn>
      <Btn onClick={() => press('7')}>7</Btn>
      <Btn onClick={() => press('8')}>8</Btn>
      <Btn onClick={() => press('9')}>9</Btn>
      <Btn onClick={() => press(',')} dim={!allowDecimal} label="запятая">{allowDecimal ? ',' : ''}</Btn>
      <Btn onClick={() => press('0')}>0</Btn>
      <Btn onClick={() => press('back')} label="стереть">⌫</Btn>
    </div>
  );
}

// Хелпер для парсинга
export function parseQty(input) {
  if (input == null || input === '') return null;
  const cleaned = String(input).replace(',', '.').trim();
  if (cleaned === '' || cleaned === '.') return null;
  const num = Number(cleaned);
  if (!isFinite(num) || num <= 0) return null;
  return num;
}
